var map = {
	"./Accordion.js": 4729,
	"./AnimatedIcon.js": 6647,
	"./ChatTrigger.js": 8389,
	"./FrontHero.js": 1220,
	"./Header.js": 1282,
	"./HeroDefault.js": 6922,
	"./Index.js": 4447,
	"./List.js": 2083,
	"./NavbarToggle.js": 8529,
	"./Reviews.js": 6530,
	"./Slider.js": 8834,
	"./VideoEmbed.js": 5671,
	"./WaitingTime.js": 1717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8965;